import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PasswordFieldComponent } from '../../../fields/standard/password-field/password-field.component';
import { AppModule } from '../../../../modules/app.module';
import { ZorroModule } from '../../../../modules/zorro.module';
import { ThirdPartyModule } from '../../../../modules/third-party.module';
import { AngularModule } from '../../../../modules/angular.module';
import { ConfirmValidator } from '../../../../validators/confirm.validator';
import { FormSubmitButtonComponent } from '../../../ui/forms/form-submit-button/form-submit-button.component';
import { FormBoxComponent } from '../../../ui/forms/form-box/form-box.component';
import { FormLabelComponent } from '../../../ui/forms/form-label/form-label.component';
import { FormLinkComponent } from '../../../ui/forms/form-link/form-link.component';
import { PasswordRequirementsComponent } from '../../../ui/password-requirements/password-requirements.component';
import { HomeState, OneTimePasswordExchangeSource } from '@mira-avant/mtlibs';
import { UrlHelper } from '../../../../utils/url.helper';

@Component({
	selector: 'app-change-temporary-password-form',
	standalone: true,
	imports: [
		AppModule,
		ZorroModule,
		ThirdPartyModule,
		AngularModule,
		PasswordFieldComponent,
		FormSubmitButtonComponent,
		FormBoxComponent,
		FormLabelComponent,
		FormLinkComponent,
		PasswordRequirementsComponent,
	],
	templateUrl: './change-temporary-password-form.component.html',
	styleUrl: './change-temporary-password-form.component.scss',
})
export class ChangeTemporaryPasswordFormComponent {
	@Output('onSubmit') public onSubmitEmitter: EventEmitter<any> = new EventEmitter<any>();
	@Output('onSwitchState') public onSwitchStateEmitter: EventEmitter<HomeState> = new EventEmitter<HomeState>();
	@Input() public studentId: string | undefined;
	@Input() public setupCode: string | undefined;
	@Input() public setupLinkExpired: boolean = false;
	@Input('loading') public loading: boolean = false;

	public form: FormGroup;
	private readonly urlCode = UrlHelper.queryString('code');
	private readonly urlSource = Object.values(OneTimePasswordExchangeSource).find(
		source => source === UrlHelper.queryString('source')
	);

	public get hasSubmitContext(): boolean {
		return Boolean(this.setupCode || (this.urlCode && this.urlSource));
	}

	constructor(private fb: FormBuilder) {
		this.form = this.fb.group(
			{
				password: ['', [...PasswordFieldComponent.validators, Validators.required]],
				confirmPassword: ['', [...PasswordFieldComponent.validators, Validators.required]],
			},
			{
				validator: ConfirmValidator('password', 'confirmPassword'),
			}
		);
	}

	onSubmit(): void {
		if (this.form.valid && !this.setupLinkExpired) {
			const isSetupCode = Boolean(this.setupCode);
			const code = this.setupCode || this.urlCode;
			const source = isSetupCode ? OneTimePasswordExchangeSource.ACCOUNT_SETUP : this.urlSource;

			if (code && source) {
				this.onSubmitEmitter.emit({
					code,
					source,
					newPassword: this.form.value.password,
				});
				return;
			}

		}
	}

	clear(): void {
		this.form.reset();
	}

	public onBack() {
		this.onSwitchStateEmitter.emit(HomeState.LOGIN);
	}

	public onRequestNewSignupLink(): void {
		this.onSwitchStateEmitter.emit(HomeState.FORGOT_PASSWORD);
	}
}
